import { defineMessages } from 'react-intl';

export const trelloWorkspaceSelectorMessages = defineMessages({
  siteLabel: {
    id: 'mcp.trelloWorkspaceSelector.siteLabel',
    defaultMessage: 'Authorize access for:',
    description:
      'Label above the Trello workspace selector when it is the only selector visible',
  },
  placeholder: {
    id: 'mcp.trelloWorkspaceSelector.placeholder',
    defaultMessage: 'Select a Trello workspace',
    description: 'Placeholder text for the Trello workspace selector',
  },
  mixedDescription: {
    id: 'mcp.trelloWorkspaceSelector.mixedDescription',
    defaultMessage:
      'A Trello workspace is also needed to allow access to your Trello boards and cards.',
    description:
      'Help text shown below the Trello workspace selector when both Atlassian site and Trello workspace selectors are visible',
  },
  noWorkspacesHeading: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesHeading',
    defaultMessage: 'No Trello workspaces found',
    description: 'Heading for empty state when user has no Trello workspaces',
  },
  noWorkspacesDescription: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesDescription',
    defaultMessage:
      "You might be signed in with an account that doesn't have Trello access. Try {switchAccountLink} or {contactSupportLink}",
    description:
      'Description for empty state when no Trello workspaces available, includes switch account and contact support links',
  },
  noWorkspacesSwitchAccount: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesSwitchAccount',
    defaultMessage: 'signing in with a different account',
    description: 'Switch account link text in Trello no-workspaces empty state',
  },
  noWorkspacesContactSupport: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesContactSupport',
    defaultMessage: 'contact support',
    description:
      'Contact support link text in Trello no-workspaces empty state',
  },
  noWorkspacesCompact: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesCompact',
    defaultMessage:
      "No Trello workspaces found. You might be signed in with an account that doesn't have Trello access. Try {switchAccountLink} or {contactSupportLink}",
    description:
      'Compact message shown in the mixed flow when no Trello workspaces are available',
  },
});
